type Child = Node | string | null | undefined | false;

interface Props {
  class?: string;
  text?: string;
  attrs?: Record<string, string>;
  on?: Partial<Record<keyof HTMLElementEventMap, (e: Event) => void>>;
}

/** 建 DOM 节点。文字一律走 textContent，名字、故事里有尖括号也不会被当成 HTML */
export function el<K extends keyof HTMLElementTagNameMap>(tag: K, props: Props = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props.class) node.className = props.class;
  if (props.text !== undefined) node.textContent = props.text;
  for (const [k, v] of Object.entries(props.attrs ?? {})) node.setAttribute(k, v);
  for (const [k, fn] of Object.entries(props.on ?? {})) if (fn) node.addEventListener(k, fn);
  for (const c of children) if (c !== null && c !== undefined && c !== false) node.append(c);
  return node;
}

export function field(label: string, input: HTMLInputElement | HTMLTextAreaElement, hint?: string): HTMLLabelElement {
  return el('label', { class: 'field' }, el('span', { class: 'field-label', text: label }), input, hint ? el('span', { class: 'field-hint', text: hint }) : null);
}

export function input(attrs: Record<string, string>): HTMLInputElement {
  return el('input', { attrs });
}
